import React from 'react';
import WorkflowDetailSection from '../../../sections/AdminDashboard/Moderation/WorkflowDetail';

const WorkflowDetail = () => {
  return <WorkflowDetailSection />;
};

export default WorkflowDetail;

